// TSS vite/01 §"Layer communication rules" — pure helpers with no React and no
// app state, so every feature may import them and none of them owns this.
//
// Lifted here the third time a feature needed the same six lines. The locale is
// fixed rather than taken from the browser: `es-CO` is the shop's, and a panel
// that shows 08/18 to one person and 18/08 to another over the same row is a
// bug report waiting to be filed.

const LOCALE = 'es-CO';

// Accepts an ISO string from the API or a millisecond timestamp from the query
// cache (`dataUpdatedAt`), because both are asked of it.
function parse(value) {
    if (value == null) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatTime(value) {
    const date = parse(value);
    return date ? date.toLocaleTimeString(LOCALE, { hour12: false }) : '--:--:--';
}

export function formatDateTime(value) {
    const date = parse(value);
    if (!date) return '—';
    return date.toLocaleString(LOCALE, {
        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
    });
}

// "hace 3 min". Coarse on purpose: this answers "is it alive?", and a second
// hand on that question is noise. Anything older than a day gets the date
// instead — "hace 47 h" is not something anybody converts in their head.
export function formatAgo(value, now = Date.now()) {
    const date = parse(value);
    if (!date) return 'nunca';

    const seconds = Math.round((now - date.getTime()) / 1000);
    if (seconds < 0) return 'recién';
    if (seconds < 60) return 'hace segundos';

    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `hace ${minutes} min`;

    const hours = Math.round(minutes / 60);
    if (hours < 24) return `hace ${hours} h`;

    return formatDateTime(value);
}
